// extracted by mini-css-extract-plugin
export default {"container":"Description_container__vH5-8","sub1":"Description_sub1__Y99mO","sub2":"Description_sub2__LFW3s","card":"Description_card__oia3q"};